import { Performer } from '../../core/performer'
import { HttpMethod } from '../../core/types'
import type { User } from './model'

export class Profile extends Performer<void, User> {
  protected method = HttpMethod.GET
  protected url = '/auth/profile'
}

export default new Profile().perform
